import {MobXProviderContext} from 'mobx-react';
import {useContext} from 'react';

const useStore = () => useContext(MobXProviderContext);

export default useStore;
